module.exports = __webpack_public_path__ + "static/media/THG.8bab0134.png";